// File type categories and corresponding icons
const FILE_CATEGORIES = {
	IMAGE: 'image',
	VIDEO: 'video', 
	AUDIO: 'audio',
	PDF: 'pdf',
	ARCHIVE: 'archive',
	WORD: 'word',
	EXCEL: 'excel',
	POWERPOINT: 'powerpoint',
	CSV: 'csv',
	CODE: 'code',
	DMG: 'dmg',
	WINDOWS: 'windows',
	DEFAULT: 'default'
};

// MIME type mappings
const MIME_TYPE_MAP = {
	// Images
	'image/': FILE_CATEGORIES.IMAGE,
	
	// Videos  
	'video/': FILE_CATEGORIES.VIDEO,
	
	// Audio
	'audio/': FILE_CATEGORIES.AUDIO,
	
	// PDF
	'application/pdf': FILE_CATEGORIES.PDF
};

// File extension mappings
const EXTENSION_MAP = {
	// Archives
	'zip': FILE_CATEGORIES.ARCHIVE,
	'rar': FILE_CATEGORIES.ARCHIVE,
	'7z': FILE_CATEGORIES.ARCHIVE,
	'tar': FILE_CATEGORIES.ARCHIVE,
	'gz': FILE_CATEGORIES.ARCHIVE,
	'bz2': FILE_CATEGORIES.ARCHIVE,
	'xz': FILE_CATEGORIES.ARCHIVE,
	'iso': FILE_CATEGORIES.ARCHIVE,
	
	// Word documents
	'doc': FILE_CATEGORIES.WORD,
	'docx': FILE_CATEGORIES.WORD,
	'odt': FILE_CATEGORIES.WORD,
	'rtf': FILE_CATEGORIES.WORD,
	
	// Excel documents  
	'xls': FILE_CATEGORIES.EXCEL,
	'xlsx': FILE_CATEGORIES.EXCEL,
	'ods': FILE_CATEGORIES.EXCEL,
	
	// PowerPoint documents
	'ppt': FILE_CATEGORIES.POWERPOINT,
	'pptx': FILE_CATEGORIES.POWERPOINT,
	'odp': FILE_CATEGORIES.POWERPOINT,
	
	// CSV files
	'csv': FILE_CATEGORIES.CSV,
	'tsv': FILE_CATEGORIES.CSV,
	
	// Code files
	'js': FILE_CATEGORIES.CODE,
	'jsx': FILE_CATEGORIES.CODE,
	'ts': FILE_CATEGORIES.CODE,
	'tsx': FILE_CATEGORIES.CODE,
	'html': FILE_CATEGORIES.CODE,
	'css': FILE_CATEGORIES.CODE,
	'php': FILE_CATEGORIES.CODE,
	'py': FILE_CATEGORIES.CODE,
	'java': FILE_CATEGORIES.CODE,
	'c': FILE_CATEGORIES.CODE,
	'cpp': FILE_CATEGORIES.CODE,
	'h': FILE_CATEGORIES.CODE,
	'cs': FILE_CATEGORIES.CODE,
	'json': FILE_CATEGORIES.CODE,
	'xml': FILE_CATEGORIES.CODE,
	
	// PDF extension fallback
	'pdf': FILE_CATEGORIES.PDF,
	
	// Installers
	'dmg': FILE_CATEGORIES.DMG,
	'exe': FILE_CATEGORIES.WINDOWS,
	'msi': FILE_CATEGORIES.WINDOWS
};

/**
 * Categorize file type based on MIME type and extension
 * @param {File} file - Browser File object
 * @returns {string} - File category for icon selection
 */
export const categorizeFileType = (file) => {
	const mimeType = file.type.toLowerCase();
	const fileName = file.name.toLowerCase();
	const extension = fileName.split('.').pop();
	
	// Check MIME type first (more reliable)
	for (const [pattern, category] of Object.entries(MIME_TYPE_MAP)) {
		if (mimeType.startsWith(pattern)) {
			return category;
		}
	}
	
	// Fallback to extension
	if (extension && EXTENSION_MAP[extension]) {
		return EXTENSION_MAP[extension];
	}
	
	// Default fallback
	return FILE_CATEGORIES.DEFAULT;
};

/**
 * Check if file is an image that can be previewed
 * @param {File} file - Browser File object  
 * @returns {boolean} - True if file can be previewed as image
 */
export const isImageFile = (file) => {
	return categorizeFileType(file) === FILE_CATEGORIES.IMAGE;
};

export { FILE_CATEGORIES };
